interface IDocumentVersion {
  id: string
  documentId: string
  createdBy: string
  createdOn: Date
  updatedBy: string
  updatedOn: Date
}

/**
 * The document version model
 */
export class DocumentVersion implements IDocumentVersion {
  id: string
  documentId: string
  createdBy: string
  createdOn: Date
  updatedBy: string
  updatedOn: Date

  constructor(documentSpace: Partial<IDocumentVersion>) {
    Object.assign(this, documentSpace)

    if (this.createdOn) {
      this.createdOn = new Date(this.createdOn)
    }

    if (this.updatedOn) {
      this.updatedOn = new Date(this.updatedOn)
    }
  }
}
